export const getListDataFilter = (data, id, value) => {
  const products = [...data];
  // const index = products?.indexOf(id);
  const index = id;
  products[index] = parseInt(value);
  return products;
};
